export const localeToBaseLanguageMap = Object.freeze({
  'es-mx': 'es',
  'fr-ca': 'fr'
});

export function useLocaleHelpers() {
  function getBaseLanguageCodeFromLocale(locale) {
    const key = locale.toLowerCase();
    return localeToBaseLanguageMap[key] ?? key;
  }

  function setLocaleToLocalStorage(userId, locale = 'en') {
    localStorage.setItem(`user_${userId}_locale`, locale);
  }

  function getLocaleFromLocalStorage(userId) {
    return localStorage.getItem(`user_${userId}_locale`) ?? 'en';
  }

  return {
    getBaseLanguageCodeFromLocale,
    setLocaleToLocalStorage,
    getLocaleFromLocalStorage
  };
}
